export default __webpack_public_path__ + "static/media/icon-2.d56d3d41.png";